import React from "react"
import Img from "gatsby-image"
import { Box, Container, Text } from "theme-ui"
import Header from "./header"
import PlaceHolderImage from "../../src/images/header-placeholder.jpg"

const PageHero = ({ title, image, children, locale }) => (
  <Box pb={[7, 8]} sx={{ position: "relative" }}>
    <Header lang={locale} />
    <Container>
      <Text
        variant="display"
        as="h1"
        sx={{ textAlign: "center", mt: [6, 7], mb: [2, 3] }}
      >
        {title}
      </Text>
      {children}
    </Container>
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: -1,
        ".gatsby-image-wrapper": {
          height: "100%",
        },
      }}
      backgroundColor="primary"
    >
      {image ? <Img fluid={image.fluid} /> : <img style={{
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center center",
      }} src={PlaceHolderImage} />}
    </Box>
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: -1,
        background: "linear-gradient(#e6461699, #00000000)",

      }}
    ></Box>
  </Box>
)

export default PageHero
